export type OrderStatus = 'confirmed' | 'preparing' | 'shipped' | 'transit' | 'delivered';

export interface TrackingEvent {
  date: string;
  time: string;
  description: string;
  location: string;
}

export interface MockOrder {
  id: string;
  product: string;
  variant: string;
  price: string;
  status: OrderStatus;
  estimatedDelivery: string;
  carrier: string;
  trackingNumber: string;
  customerName: string;
  shippingAddress: string;
  events: TrackingEvent[];
}

export const mockOrders: Record<string, MockOrder> = {
  'HLX-2025-001': {
    id: 'HLX-2025-001',
    product: 'HELIX Ring',
    variant: 'Premium — Talla 9 — Titanio Negro',
    price: '79,99 €',
    status: 'delivered',
    estimatedDelivery: '12 mar 2025',
    carrier: 'DHL Express',
    trackingNumber: '1234567890',
    customerName: 'Carlos M.',
    shippingAddress: 'Calle Gran Vía 45, 28013 Madrid',
    events: [
      { date: '12 mar', time: '14:22', description: 'Entregado en destino', location: 'Madrid, España' },
      { date: '12 mar', time: '09:10', description: 'En reparto', location: 'Madrid, España' },
      { date: '11 mar', time: '22:45', description: 'Llegó al centro de distribución local', location: 'Coslada, Madrid' },
      { date: '10 mar', time: '18:30', description: 'En tránsito internacional', location: 'Frankfurt, Alemania' },
      { date: '09 mar', time: '11:00', description: 'Paquete enviado', location: 'Barcelona, España' },
      { date: '08 mar', time: '09:00', description: 'Pedido en preparación', location: 'Almacén HELIX, Barcelona' },
      { date: '07 mar', time: '16:34', description: 'Pedido confirmado y pago recibido', location: '' },
    ],
  },
  'HLX-2025-042': {
    id: 'HLX-2025-042',
    product: 'HELIX Ring',
    variant: 'Esencial — Talla 7 — Titanio Plata',
    price: '49,99 €',
    status: 'transit',
    estimatedDelivery: '19 mar 2025',
    carrier: 'DHL Express',
    trackingNumber: '9876543210',
    customerName: 'Laura G.',
    shippingAddress: 'Avinguda Diagonal 200, 08013 Barcelona',
    events: [
      { date: '17 mar', time: '08:50', description: 'En tránsito hacia destino final', location: 'Barcelona, España' },
      { date: '16 mar', time: '21:15', description: 'Llegó al centro de distribución local', location: 'El Prat, Barcelona' },
      { date: '15 mar', time: '14:00', description: 'Enviado desde almacén', location: 'Barcelona, España' },
      { date: '14 mar', time: '10:30', description: 'Pedido en preparación y empaquetado', location: 'Almacén HELIX, Barcelona' },
      { date: '13 mar', time: '20:12', description: 'Pedido confirmado y pago recibido', location: '' },
    ],
  },
  'HLX-2025-089': {
    id: 'HLX-2025-089',
    product: 'HELIX Ring',
    variant: 'Premium — Talla 10 — Titanio Oro',
    price: '79,99 €',
    status: 'preparing',
    estimatedDelivery: '21 mar 2025',
    carrier: 'DHL Express',
    trackingNumber: 'Pendiente de asignación',
    customerName: 'Andrés R.',
    shippingAddress: 'Calle Sierpes 22, 41004 Sevilla',
    events: [
      { date: '17 mar', time: '11:00', description: 'Pedido en preparación y empaquetado', location: 'Almacén HELIX, Barcelona' },
      { date: '17 mar', time: '09:44', description: 'Pedido confirmado y pago recibido', location: '' },
    ],
  },
  'HLX-2025-156': {
    id: 'HLX-2025-156',
    product: 'HELIX Ring',
    variant: 'Esencial — Talla 8 — Titanio Negro',
    price: '49,99 €',
    status: 'confirmed',
    estimatedDelivery: '22 mar 2025',
    carrier: 'DHL Express',
    trackingNumber: 'Pendiente de asignación',
    customerName: 'Marta S.',
    shippingAddress: 'Calle Larios 10, 29005 Málaga',
    events: [
      { date: '18 mar', time: '08:22', description: 'Pedido confirmado y pago recibido', location: '' },
    ],
  },
};

export const statusConfig: Record<OrderStatus, { label: string; color: string; icon: string; bgColor: string }> = {
  confirmed: {
    label: 'Confirmado',
    color: 'text-amber-700',
    bgColor: 'bg-amber-50',
    icon: 'ri-checkbox-circle-line',
  },
  preparing: {
    label: 'En preparación',
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
    icon: 'ri-box-3-line',
  },
  shipped: {
    label: 'Enviado',
    color: 'text-sky-600',
    bgColor: 'bg-sky-50',
    icon: 'ri-send-plane-line',
  },
  transit: {
    label: 'En camino',
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    icon: 'ri-truck-line',
  },
  delivered: {
    label: 'Entregado',
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
    icon: 'ri-map-pin-check-line',
  },
};

export const allSteps: { key: OrderStatus; label: string; icon: string }[] = [
  { key: 'confirmed', label: 'Confirmado', icon: 'ri-checkbox-circle-line' },
  { key: 'preparing', label: 'Preparando', icon: 'ri-box-3-line' },
  { key: 'shipped', label: 'Enviado', icon: 'ri-send-plane-line' },
  { key: 'transit', label: 'En camino', icon: 'ri-truck-line' },
  { key: 'delivered', label: 'Entregado', icon: 'ri-map-pin-check-line' },
];
